import { DISTRICT_ZOOM } from '@/common/components/AMap/ts-config';
import { FC, useEffect, useRef } from 'react';
import { pointMarkerZIndex } from './MarkerCon';
import { showViewAreaNameZoom } from '../../../../ts-config';
import { deepCopy, isNotEmpty } from '@lhb/func';
import { useDebounceEffect } from '@/common/hook/useEffectDebounce';
import { businessStatus } from '../../ts-config';

/**
 * @Description 点位marker的样式、元素交互（hover、click）
 */
const PointMarker:FC<{
  newPointData,
  pointStyle,
  mapIns,
  curSelectRef,
  hasClickRef,
  clickAddressMarker,
  pointListRef,
  // setItemData,
  allPointData,
  locationInfo,
  targetZoomNamesMarkerRef, // 指定缩放区域时显示的所有的name的覆盖物
  curZoom, // 当前缩放级别
  viewAreaData, // 可视区域内的开店区域数据
  isBatchCollect, // 是否是批量收藏状态收藏
  batchCollectIds, // 批量收藏的开店区域id
  setBatchCollectIds, // 设置批量收藏的开店区域id
  hoverPolygonId, // hover围栏对应的点位id
  setHoverPolygonId,
}> = ({
  newPointData,
  pointStyle,
  mapIns,
  curSelectRef,
  hasClickRef,
  clickAddressMarker,
  pointListRef,
  // setItemData,
  allPointData,
  locationInfo,
  targetZoomNamesMarkerRef, // 指定缩放区域时显示的所有的name的覆盖物
  curZoom, // 当前缩放级别
  viewAreaData, // 可视区域内的开店区域数据
  isBatchCollect, // 是否是批量收藏状态收藏
  batchCollectIds, // 批量收藏的开店区域id
  setBatchCollectIds, // 设置批量收藏的开店区域id
  hoverPolygonId, // hover围栏对应的点位id
  setHoverPolygonId,
}) => {
  const isInitRef = useRef<boolean>(true);// 是否是初始化过程，没有打开品牌商圈情况下，默认点位距离最近的
  const isBatchCollectRef: any = useRef(); // 存放最新的是否是批量收藏状态
  const batchCollectIdsRef: any = useRef([]); // 存放最新的批量选中项ids
  // 绘制商圈点位marker
  const drawPoint = (value) => {

    const marker = new window.AMap.Marker({
      position: new window.AMap.LngLat(+value?.lng, +value?.lat),
      anchor: 'center',
      zIndex: pointMarkerZIndex,
      zooms: [DISTRICT_ZOOM, 20],
      bubble: true, // 允许冒泡
      extData: {
        ...value,
      }
    });
    mapIns.add(marker);

    marker.setContent(pointStyle(value, false));

    marker.on('mouseover', () => {
      setHoverPolygonId(value.id);
    });

    marker.on('mouseout', () => {
      setHoverPolygonId(0);
    });

    marker.on('click', () => {
      hasClickRef.current = true;
      clickAddressMarker(value);
    });
    pointListRef.current.push(marker);
    mapIns.add(marker);
  };
  const getTargetMarkerId = (marker: any) => {
    const { _opts } = marker || {};
    const { extData } = _opts || {};
    const { id } = extData || {};
    return id;
  };
  // 当前覆盖物集合中是否包含指定的marker
  const containTargetMarker = (targetId: number) => {
    const markers = targetZoomNamesMarkerRef.current;
    const len = markers.length;
    let targetMarker = null;
    for (let i = 0; i < len; i++) {
      if (targetId === getTargetMarkerId(markers[i])) {
        targetMarker = markers[i];
        break;
      }
    }
    return targetMarker;
  };
  const getNameMarkerContent = (item: any, hasCheckbox = false) => {
    const { id } = item;
    const isChecked = batchCollectIdsRef.current.includes(id);
    return `<div class='nameMarkerCon'>
        ${hasCheckbox ? `<svg
          class='svgIcon'
          aria-hidden>
            <use xlink:href=${isChecked ? '#iconduoxuanxuanzhong' : '#iconduoxuan'} />
        </svg>` : ''}
        <span class=${hasCheckbox ? 'pl-4' : ''}>
          ${item?.status === businessStatus.NEW ? '<span class="c-ff8 fs-12 pr-4">新增</span>' : (isNotEmpty(item.rank) ? `${item.rank + 1}.` : '')}
        </span>
        <span>${item.areaName}</span>
      </div>`;
  };
  // 缩放到showViewAreaNameZoom层级时，显示所有开店区域的名称marker
  const drawNameMarker = (item: any, hasCheckbox = false) => {
    const { id } = item;
    // 是否已经添加到地图了
    const targetMarker: any = containTargetMarker(id);
    if (targetMarker) { // 已经存在就只设置content
      const markerContent = getNameMarkerContent(item, hasCheckbox);
      targetMarker.setContent(markerContent);
      return;
    };
    const marker = new window.AMap.Marker({
      position: new window.AMap.LngLat(+item?.lng, +item?.lat),
      offset: [0, 15],
      zIndex: pointMarkerZIndex,
      zooms: [showViewAreaNameZoom, 20],
      extData: {
        ...item,
      },
      content: getNameMarkerContent(item, hasCheckbox)
    });
    // 绑定点击事件
    marker.on('click', () => {
      hasClickRef.current = true;
      clickAddressMarker(item);

      if (!isBatchCollectRef.current) return;
      const isChecked = batchCollectIdsRef.current.includes(id);
      const targetIds = deepCopy(batchCollectIdsRef.current);

      if (isChecked) { // 已经是选中，那就取消选中
        const indexOf = targetIds.indexOf(item.id);
        if (indexOf !== -1) {
          targetIds.splice(indexOf, 1);
          setBatchCollectIds(targetIds);
        }
        return;
      }
      // 选中
      const ids = [...targetIds, id];
      setBatchCollectIds(ids);
    });

    targetZoomNamesMarkerRef.current.push(marker);

    marker.on('mouseover', () => {
      setHoverPolygonId(item.id);
    });

    marker.on('mouseout', () => {
      setHoverPolygonId(0);
    });
    mapIns.add(marker);
  };
  // 初始化，寻找距离最近的开店区域marker
  const initDistancePoint = () => {
    if (!isInitRef.current) return;
    // 存放距离最近的项
    let shortestDistanceItem: any = {
      distance: Number.MAX_VALUE
    };
    // 对需要新加的数据进行遍历
    allPointData.forEach((item) => {
      if (isInitRef.current && item?.lng && item?.lat && locationInfo?.lng && locationInfo?.lat) {
        const distance = window.AMap.GeometryUtil.distance([item.lng, item.lat], [locationInfo.lng, locationInfo.lat]);
        if (distance < shortestDistanceItem.distance) {
          shortestDistanceItem = {
            ...item,
            distance
          };
        }
      }
    });
    if (isInitRef.current && allPointData.length && +shortestDistanceItem?.lng && +shortestDistanceItem?.lat) {
      // 初始化时，选中距离最近的marker
      // mapIns.setCenter([+shortestDistanceItem.lng, +shortestDistanceItem.lat], true);
      // setItemData({
      //   id: shortestDistanceItem.id,
      //   detail: shortestDistanceItem,
      //   visible: true,
      //   isFirst: true,
      // });
      isInitRef.current = false;
    }
  };
  useEffect(() => {
    if (!mapIns) return;
    // const zoom = mapIns.getZoom();
    newPointData.forEach((item) => {
      drawPoint(item);
    });
    initDistancePoint();
  }, [mapIns, newPointData]);

  useDebounceEffect(() => {
    if (!mapIns) return;
    isBatchCollectRef.current = isBatchCollect;
    batchCollectIdsRef.current = batchCollectIds;
    // 地图缩放级别到指定级别以后，清空
    if (curZoom < showViewAreaNameZoom) {
      targetZoomNamesMarkerRef.current?.map((marker) => {
        mapIns.remove(marker);
      });
      targetZoomNamesMarkerRef.current = [];
      return;
    }
    const viewAreaDataIds = viewAreaData.map((item) => item.id);
    // 删除掉不在当前可视区域内的覆盖物
    const arr = targetZoomNamesMarkerRef.current.filter((itemMarker) => {
      const markerId = getTargetMarkerId(itemMarker);
      const flag = viewAreaDataIds.includes(markerId);
      if (!flag) {
        mapIns.remove(itemMarker);
      }
      return flag;
    });
    targetZoomNamesMarkerRef.current = arr;

    // 可视区域内绘制name marker
    viewAreaData?.forEach((item: any) => {
      drawNameMarker(item, isBatchCollect);
    });
  }, [mapIns, viewAreaData, curZoom, isBatchCollect, batchCollectIds], 200);

  // hover逻辑（这样做，而不是直接写到mouseover\mouseout的原因是hover围栏也需要点位变颜色）
  useEffect(() => {
    if (!hoverPolygonId) return;
    // 有围栏id时hover
    pointListRef.current?.forEach((marker) => {
      const value = marker?.getExtData();
      if (hoverPolygonId === value?.id) {
        if (curSelectRef.current?.id === value?.id) return;
        marker.setContent(pointStyle(value, true));
        marker.setzIndex(pointMarkerZIndex + 1);
      }
    });

    // 清除上一次的hover
    return () => {
      pointListRef.current?.forEach((marker) => {
        const value = marker?.getExtData();
        if (hoverPolygonId === value?.id) {
          if (curSelectRef.current?.id === value.id) return;
          marker.setContent(pointStyle(value, false));
          marker.setzIndex(pointMarkerZIndex);
        }
      });
    };
  }, [hoverPolygonId]);
  return <></>;
};

export default PointMarker;
